import { IconTooltip } from '@/components/icon-tooltip'
import { useTranslate } from '@ur-solutions/react-hooks'
import type { IssueActionLog } from '..'
import { parseExportLogMetadata } from './export-log-metadata'

type Props = {
  node: IssueActionLog
}

export const ExportMetadataTooltip = ({ node }: Props) => {
  const translations = useTranslate({
    method: 'issues.export-detail-method',
    format: 'issues.export-detail-format',
    recipients: 'issues.export-detail-recipients',
  })

  const metadata = parseExportLogMetadata(node.metadata)
  if (!metadata) return null

  const recipients = metadata.recipients ?? []

  return (
    <IconTooltip triggerClassName="ml-2 align-middle text-secondary">
      <div className="flex flex-col gap-1 text-left">
        {metadata.export_option && (
          <span>
            {translations.method}: {metadata.export_option.toUpperCase()}
          </span>
        )}
        {metadata.export_format && (
          <span>
            {translations.format}: {metadata.export_format.toUpperCase()}
          </span>
        )}
        {recipients.length > 0 && (
          <span>
            {translations.recipients}: {recipients.join(', ')}
          </span>
        )}
      </div>
    </IconTooltip>
  )
}
